export const currencySymbols = {
  USD: '$', // US Dollar
  EUR: '€', // Euro
  GBP: '£', // British Pound Sterling
  PLN: 'zł', // Polish Zloty
};

export const notAvaiblePaymentMethods = ['2_b']; // 2_b means traditional transfer
